import React from 'react';
import { Check, X } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
export function LocalHosting() {
  const comparison = [{
    feature: 'Pricing model',
    big: 'Metered, hard to forecast',
    us: 'Flat monthly rate'
  }, {
    feature: 'Support',
    big: 'Ticket queues, escalation paths',
    us: 'Direct line to an engineer'
  }, {
    feature: 'Data location',
    big: "A region you can't name",
    us: 'Local infrastructure in Boston'
  }, {
    feature: 'Lock-in',
    big: 'Proprietary services, migration cost',
    us: 'Standard stack, leave anytime'
  }, {
    feature: 'Onboarding',
    big: 'Self-serve, on you to configure',
    us: 'We set it up with you'
  }];
  return <section className="py-16" data-id="element-107">
      <SectionLabel number="04" label="Local hosting" data-id="element-108" />
      <h2 className="font-display text-4xl md:text-5xl text-ink mb-3 max-w-2xl leading-[1.05]" data-id="element-109">
        An alternative to AWS{' '}
        <span className="italic text-brand-teal" data-id="element-110">
          that you can actually call.
        </span>
      </h2>
      <p className="text-lg text-ink-muted mb-10 max-w-2xl" data-id="element-111">
        Big cloud is built for scale you may never need — at prices you can't
        forecast, with support you can't reach. Here's how local hosting
        compares.
      </p>

      <div className="rounded-2xl border border-ink/10 overflow-hidden bg-surface-paper" data-id="element-112">
        <div className="grid grid-cols-3 bg-ink text-white" data-id="element-113">
          <div className="px-4 md:px-6 py-4 text-xs font-semibold tracking-[0.15em] uppercase text-white/60" data-id="element-114">
            &nbsp;
          </div>
          <div className="px-4 md:px-6 py-4 text-xs font-semibold tracking-[0.15em] uppercase text-white/60 border-l border-white/10" data-id="element-115">
            Big cloud
          </div>
          <div className="px-4 md:px-6 py-4 text-xs font-semibold tracking-[0.15em] uppercase text-brand-mint border-l border-white/10" data-id="element-116">
            MaytoMation
          </div>
        </div>
        {comparison.map((row, i) => <div key={row.feature} className={`grid grid-cols-3 ${i < comparison.length - 1 ? 'border-b border-ink/10' : ''}`} data-id="element-117">
            <div className="px-4 md:px-6 py-4 text-sm font-semibold text-ink" data-id="element-118">
              {row.feature}
            </div>
            <div className="px-4 md:px-6 py-4 text-sm text-ink-muted border-l border-ink/10 flex items-start gap-2" data-id="element-119">
              <X className="w-4 h-4 text-ink-muted/60 flex-shrink-0 mt-0.5" data-id="element-120" />
              <span data-id="element-121">{row.big}</span>
            </div>
            <div className="px-4 md:px-6 py-4 text-sm text-ink border-l border-ink/10 flex items-start gap-2 bg-brand-mint/[0.06]" data-id="element-122">
              <Check className="w-4 h-4 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-123" />
              <span data-id="element-124">{row.us}</span>
            </div>
          </div>)}
      </div>

      <div className="mt-8" data-id="element-125">
        <a href="/services#hosting" className="inline-flex items-center gap-2 text-white font-semibold rounded-xl px-6 py-3 bg-gradient-to-r from-brand-deep to-brand-teal transition-all duration-200 hover:-translate-y-0.5 hover:shadow-hero" data-id="element-126">
          See if local hosting fits you
        </a>
      </div>
    </section>;
}